import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZActivityFeedItemResponse } from './models';

const c = initContract();
export const publicActivtyFeedContract = c.router(
  {
    getActivityFeedItems: {
      method: 'GET',
      path: '/',
      query: z.object({
        lastEventId: z.optional(z.coerce.number()),
      }),
      responses: {
        200: ZActivityFeedItemResponse,
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/public',
  }
);
